var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartbeat2 = function SvgIconHeartbeat2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_heartbeat_2_svg2__a",
    x1: 13.03,
    x2: 92.57,
    y1: 67.3,
    y2: 15.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 50.89H83.08c1.89-3.05 3.07-6.57 3.43-10.36.08-.81-.51-1.52-1.32-1.6s-1.52.51-1.6 1.32c-.38 3.94-1.82 7.67-4.08 10.64h-9.78l-3.84-5.6a1.45 1.45 0 0 0-1.32-.63c-.52.04-.98.35-1.21.82l-3.51 7.17-6.6-17.08c-.23-.6-.83-.98-1.47-.93s-1.18.51-1.32 1.14l-5.43 23.94-7.94-16.44a1.45 1.45 0 0 0-1.21-.82c-.52-.04-1.03.21-1.32.64l-5.26 7.81h-8.8c-5.82-7.62-5.57-19.26.76-26.53 3.14-3.6 7.29-5.58 11.69-5.58s8.56 1.98 11.69 5.58l4.27 4.9c.28.32.68.5 1.1.5s.83-.18 1.1-.5l4.27-4.9c3.14-3.6 7.29-5.58 11.69-5.58s8.56 1.98 11.69 5.58c1.91 2.19 3.34 4.9 4.15 7.85.21.78 1.02 1.24 1.8 1.02.78-.21 1.24-1.02 1.02-1.8-.92-3.37-2.57-6.48-4.77-9-3.7-4.25-8.64-6.59-13.9-6.59s-10.2 2.34-13.9 6.59L50 26.08l-3.16-3.63c-3.7-4.25-8.64-6.59-13.9-6.59s-10.2 2.34-13.9 6.59c-3.65 4.19-5.66 9.75-5.66 15.66 0 4.64 1.24 9.08 3.55 12.8H1.46c-.81 0-1.46.66-1.46 1.46s.66 1.46 1.46 1.46h17.63l4.21 4.83s.05.05.07.08l3.09 3.09c.29.29.66.43 1.03.43s.75-.14 1.04-.43c.57-.57.57-1.5 0-2.07l-3.06-3.05-2.5-2.87h7.09c.49 0 .94-.24 1.22-.65l4.27-6.34 8.65 17.91c.25.51.76.83 1.32.83h.17c.62-.07 1.12-.52 1.26-1.13l5.29-23.34 6.08 15.73c.21.54.72.91 1.3.94s1.12-.3 1.38-.82l3.88-7.93 2.86 4.17c.27.4.73.64 1.21.64h8.06l-2.5 2.87-24.52 24.46-16.52-16.49c-.57-.57-1.5-.57-2.07 0s-.57 1.5 0 2.07l16.66 16.62a2.726 2.726 0 0 0 3.86 0l24.69-24.63s.05-.05.07-.08l4.21-4.83h17.63c.81 0 1.46-.66 1.46-1.46s-.66-1.46-1.46-1.46Z",
    style: {
      fill: "url(#icon_heartbeat_2_svg2__a)"
    }
  }));
};
export default SvgIconHeartbeat2;